var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"audio",attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.audioInfo.audioUrl,"type":"audio/mp3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }